import React, {Component, PureComponent} from 'react';
import {List, WingBlank, Modal, WhiteSpace, Button} from 'antd-mobile';
import {Icon} from 'antd';
import "./index.scss"
import history from './../../utils/history';
import {getUserInfo, isRegisterFun} from './store/actionCreators';
import {connect} from 'react-redux';
import {
    AccountBookTwoTone,
    DollarCircleTwoTone,
    DatabaseTwoTone,
    CreditCardTwoTone,
    PhoneTwoTone,
    LockTwoTone,
    ProfileTwoTone
} from '@ant-design/icons';


const Item = List.Item;
const Brief = Item.Brief;
const alert = Modal.alert;

class My extends PureComponent {

    constructor(props) {
        super(props);
    }

    handleNavUrl(url) {
        history.push(url, {customerDetail: "/my"});
    }


    extraClick = () => {
        let storage = Storage.Base.getInstance();
        storage.remove("_loginTk");
        storage.remove("code");
        window.location.href = `/login`;
    }

    alertTip = () => {
        alert('退出登录', '确认要退出登录吗？', [
            {text: '取消', onPress: () => console.log('cancel')},
            {text: '确认', onPress: () => this.extraClick()},
        ])
    }

    render() {
        const userInfo = this.props;
        const {picture, type, name, balance, cardNo, tel} = userInfo.userInfo;
        console.log(picture)
        return (
            <>
            <div className={type == 3 ? "my-list" : "none-vip"}>
                {type == 3 ?
                    <div className="user-info" title="点击修改资料">
                        {picture ?
                            <img className="user-logo" src={picture} onClick={() => {
                                this.handleNavUrl("/modify")
                            }}/> :
                            <Icon type="user" className="user-logo" style={{
                                fontSize: '66px',
                                color: '#FD9D24'
                            }} onClick={() => {
                                this.handleNavUrl("/modify")
                            }}/>}
                        <div className="user-detail">
                            <div className="user-name" onClick={() => {
                                this.handleNavUrl("/modify")
                            }}>
                                {name}
                                <p style={{margin: "10px 0", textAlign: "left"}}>{tel}</p>
                            </div>
                            {/*<Button onClick={() => {*/}
                            {/*history.push("/recharge");*/}
                            {/*}} className="recharge-btn"*/}
                            {/*>充值</Button>*/}
                        </div>
                        <div className="my-vip">
                            <div className="detail">
                                <p>卡号:</p>
                                <p>{cardNo}</p>
                            </div>
                            <div className="detail" style={{marginTop: "10px", opacity: "0.23", color: "#A9601F"}}>|
                            </div>
                            <div className="detail"><p>余额:</p><p>{balance / 100}元</p></div>
                        </div>
                    </div>
                    :
                    <div className="user-info">
                        {picture ?
                            <img className="user-logo" src={picture}/> :
                            <Icon type="user" className="user-logo" style={{
                                fontSize: '66px',
                                color: '#FD9D24'
                            }}/>}
                        <div className="user-detail">
                            <div className="user-name">
                                {name}
                                <p style={{margin: "10px 0", textAlign: "left"}}>{tel}</p>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {type == 3 ?
                <div>
                    {/*<Item*/}
                    {/*thumb={<PhoneTwoTone twoToneColor="#FD9D24"/>}*/}
                    {/*onClick={() => {*/}
                    {/*this.handleNavUrl("/modify")*/}
                    {/*}}*/}
                    {/*wrap="true"*/}
                    {/*extra={tel}*/}
                    {/*multipleLine*/}
                    {/*arrow="horizontal"*/}
                    {/*>*/}
                    {/*我的资料*/}
                    {/*</Item>*/}
                    <Item
                        //thumb={<Icon type="dollar" style={{fontSize: '26px', color: '#08c'}}/>}
                        thumb={<DollarCircleTwoTone twoToneColor="#FD9D24"/>}
                        onClick={() => {
                            this.handleNavUrl("/myCharge")
                        }}
                        arrow="horizontal"
                    >
                        我的充值
                    </Item>

                    <Item
                        //thumb={<Icon type="bars" style={{fontSize: '26px', color: '#08c'}}/>}
                        thumb={<DatabaseTwoTone twoToneColor="#FD9D24"/>}
                        onClick={() => {
                            this.handleNavUrl("/myOrder")
                        }}
                        arrow="horizontal"
                    >
                        我的预约
                    </Item>
                    <Item
                        thumb={<ProfileTwoTone twoToneColor="#FD9D24"/>}
                        onClick={() => {
                            this.handleNavUrl("/consume")
                        }}
                        arrow="horizontal"
                    >
                        消费记录
                    </Item>
                </div>
                : <div>
                    <Item
                        //thumb={<Icon type="bars" style={{fontSize: '26px', color: '#08c'}}/>}
                        thumb={<DatabaseTwoTone twoToneColor="#FD9D24"/>}
                        onClick={() => {
                            this.handleNavUrl("/myOrder")
                        }}
                        arrow="horizontal"
                    >
                        我的预约
                    </Item>
                </div>
            }

            <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
            <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
            <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
            <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
            <List>
                <Item
                    onClick={() => {
                        this.alertTip()
                    }}
                    className="login-out"
                    style={{textAlign: "center"}}
                >
                    <span style={{textAlign: "center"}}>退出登录</span>
                </Item>
            </List>
            </>
        )
    }

    componentDidMount() {
        let storage = Storage.Base.getInstance();
        let oauthInfo = storage.get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        this.props.getUserInfo();
    }

}

const mapStateToProps = (userInfo) => {
    return {
        userInfo: userInfo.userInfo.userInfo
    }
};

const mapDispatchToProps = (dispatch) => ({
    getUserInfo: () => dispatch(getUserInfo()),
    isRegisterFun: (param) => dispatch(isRegisterFun(param))
});

export default connect(mapStateToProps, mapDispatchToProps)(My);

